import { MarketCodes, Market } from '../types/market';

import gb from './gb';
import se from './se';
import fi from './fi';
import fr from './fr';
import no from './no';
import nz from './nz';
import dk from './dk';

const markets: Record<MarketCodes, Market> = {
  se,
  gb,
  fi,
  fr,
  no,
  nz,
  dk,
};

const marketCodes = ['dk', 'fi', 'fr', 'gb', 'no', 'nz', 'se'] as const;

export { marketCodes };

export default markets;
